import { render, staticRenderFns } from "./ExtensionDetails.vue?vue&type=template&id=249fb927&"
import script from "./ExtensionDetails.vue?vue&type=script&lang=js&"
export * from "./ExtensionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports